import type { AuthUser } from '@/types/auth'

export const stepTextMap = {
  idle: {
    heading: 'Sign In or Register',
    button: 'Continue with Email',
    loading: 'Verifying Email',
  },
  login: {
    heading: 'Login',
    button: 'Login',
    loading: 'Signing In',
  },
  register: {
    heading: 'Register',
    button: 'Sign Up',
    loading: 'Registering',
  },
  resetPassword: {
    heading: 'Forgot Password',
    button: 'Send Reset Email',
    loading: 'Sending Email',
  },
  preference: {
    heading: 'Make it Personal',
    button: 'Yes Please!',
    loading: 'Saving Preference',
  },
  validateEmail: {
    heading: 'Validate Email',
  },
}

export const parseUserProfile = (user: AuthUser) => {
  const { 'about-you': aboutYou = {} } = user.user_metadata || {}
  const { dob = '' } = typeof aboutYou === 'object' ? aboutYou : {}

  const [day = '', month = '', year = ''] = dob.split('/')

  const socials = ['google-oauth2', 'apple', 'facebook']

  const identities = user?.identities.length
    ? user.identities.filter((identity) => socials.includes(identity.provider))
    : []

  const canUpdateName: boolean = identities.length === 0

  const [first_name, last_name] = user.name.split(' ')

  return {
    dob: { day, month, year },
    profile: {
      user_id: user.user_id || '',
      first_name: first_name || '',
      last_name: last_name || '',
      name: user.name || '',
      canUpdateName,
    },
    aboutYou,
    metadata: user.user_metadata || {},
  }
}
